import { StatusBackgroundColor } from '@modules/UserStatusModule/statusValues';
import { tokens } from '@servicetitan/tokens/core';
import styled from 'styled-components';

type UserStatusDropdownButtonProps = {
  $status: string;
};

type UserStatusDropdownMenuProps = {
  open: boolean;
};

export const UserStatusDropdown = styled.div`
  position: relative;
`;

export const UserStatusDropdownButton = styled.button<UserStatusDropdownButtonProps>`
  background-color: ${({ $status }) => StatusBackgroundColor[$status]};
  cursor: pointer;

  min-width: 152px;
  padding: 2px 4px;

  border-radius: ${tokens.borderRadiusPill};
  border-color: transparent;

  .Spinner {
    height: 12px;
    width: 12px;
  }
`;

export const UserStatusDropdownListButton = styled.button<UserStatusDropdownButtonProps>`
  background-color: ${({ $status }) => StatusBackgroundColor[$status]};
  cursor: pointer;

  width: 145px;
  padding: 2px 4px;

  border-radius: ${tokens.borderRadiusPill};
  border-color: transparent;
`;

export const UserStatusDropdownMenu = styled.div<UserStatusDropdownMenuProps>`
  display: ${({ open }) => (open ? 'flex' : 'none')};
  position: absolute;
  left: -${tokens.spacing1};
  margin: ${tokens.spacing1};
  margin-top: 3px; /* to match the design */
  padding-bottom: 11px; /* to match the design */
  min-width: 150px;

  border-radius: ${tokens.defaultBorderRadius};
  border: 1px solid ${tokens.colorNeutral60};
  background-color: ${tokens.colorNeutral0};
  box-shadow: 0px 8px 24px 0px ${tokens.shadowColor};
`;
